import { useMutation } from "@tanstack/react-query";
import { deletePartiesPublicID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useDeletePartyMutation = ({ onSuccess, onError }: Props = {}) =>
  useMutation({
    mutationFn: processResponseWithApiProblemDetails((publicID: string) =>
      deletePartiesPublicID(publicID),
    ),
    onSuccess,
    onError,
  });
